import { useMemo } from "react";
import { getFromLocalStorage } from "../utils/localStorageHelpers";

const useLoyaltyCouponConfig = ({ isLoyaltyApplied, isCouponApplied }) => {
  return useMemo(() => {
    const appConfig = getFromLocalStorage("appConfig") || {};
    const allConfigs = appConfig.all || {};

    // Helper to get flag safely, defaulting to true if the key is missing entirely or has no flag property
    const getFlag = (key) => (allConfigs[key]?.flag !== undefined ? allConfigs[key]?.flag : true);

    const isLoyaltyEnabled = getFlag("LOYALTY");
    const isCouponEnabled = getFlag("COUPON");
    const isLoyaltyAndCouponEnabled = getFlag("LOYALTY_AND_COUPON");

    // Base states (if feature is completely disabled, we disable the button)
    let disableLoyalty = !isLoyaltyEnabled;
    let disableCoupon = !isCouponEnabled;

    // Mutual Exclusion Logic
    // We only run this logic if BOTH features are individually enabled.
    if (isLoyaltyEnabled && isCouponEnabled) {
      if (!isLoyaltyAndCouponEnabled) {
        // They cannot be applied together
        if (isLoyaltyApplied) {
          disableCoupon = true;
        }
        if (isCouponApplied) {
          disableLoyalty = true;
        }
      }
    }

    return {
      isLoyaltyEnabled,
      isCouponEnabled,
      disableLoyalty,
      disableCoupon,
    };
  }, [isLoyaltyApplied, isCouponApplied]);
};

export default useLoyaltyCouponConfig;
